module.exports = __webpack_public_path__ + "static/media/leiden-placuta.9e33a393.png";